import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@store/Themes/common/mixins/spacing";

export const orderSubtitleSpacingStyles = () => spacingStyles(null, pxToRem(16));
